<template>
  <van-empty image="error" description="请在微信客户端中打开预览链接" />
</template>

<script>
import { Empty } from "vant";
export default {
  name: "Emptyview",
  components: {
    [Empty.name]: Empty,
  },
};
</script>

<style lang="scss" scoped></style>
